import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the products view.
 * @extends JetView
 */
export default class productsView extends JetView {
    /**
     * Configures the view layout and initializes data structures.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_id = this.getParam('CloseBoxId', true); // Get the CloseBoxId parameter
        var send = {
            // Object to hold data to be sent
            products: [],
            expenses: [],
            incomes: [],
            total: {
                initialmoney: 0,
                incomes: 0,
                expense: 0,
                incomesCreditCards: 0,
                total: 0,
                totalCash: 0,
            },
            CloseBoxId: cur_id,
        };

        // Event listener for productsObject event
        this.on(this.app, 'productsObject', (filter) => {
            $$('gridProduct2').data.each(function (obj) {
                send.products.push(obj); // Add each product to the send object
                send.products.splice($$('gridProduct2').count()); // Remove excess products
            });
        });

        // Delay function to process products after a timeout
        webix.delay(
            function () {
                $$('gridProduct2').data.each(function (objj) {
                    send.products.push(objj); // Add each product to the send object
                    send.products.splice($$('gridProduct2').count()); // Remove excess products
                });
            },
            '',
            '',
            1000,
        );

        // Event listener for expensesObject event
        this.on(this.app, 'expensesObject', (filter) => {
            send.expenses = []; // Reset expenses array
            $$('grid2').data.each(function (obj) {
                send.expenses.push(obj); // Add each expense to the send object
            });
        });

        // Event listener for incomesObject event
        this.on(this.app, 'incomesObject', (filter) => {
            send.incomes = []; // Reset incomes array
            console.log($$('gridIncomes2').serialize()); // Log current incomes
            $$('gridIncomes2').data.each(function (obj) {
                send.incomes.push(obj); // Add each income to the send object
            });
        });

        // Return the layout configuration
        return {
            rows: [
                {
                    view: 'text',
                    label: _('Dinero Inicial:'), // Initial money label
                    labelWidth: 120,
                    readonly: true,
                    id: 'initialmoney', // ID for the initial money field
                },
                {
                    view: 'text',
                    label: _('Total Ingresos:'), // Total income label
                    labelWidth: 120,
                    readonly: true,
                    id: 'totalIncomes', // ID for the total incomes field
                },
                {
                    view: 'text',
                    label: _('Total Egresos:'), // Total expenses label
                    labelWidth: 120,
                    readonly: true,
                    id: 'totalExpenses', // ID for the total expenses field
                },
                {
                    view: 'text',
                    label: _('Ingresos Tarjeta Credito:'), // Credit card income label
                    labelWidth: 120,
                    readonly: true,
                    id: 'incomesCreditCards', // ID for the credit card incomes field
                },
                {
                    view: 'text',
                    label: _('Total:'), // Total label
                    labelWidth: 120,
                    readonly: true,
                    id: 'total', // ID for the total field
                },
                {
                    view: 'text',
                    label: _('Total Caja:'), // Total cash label
                    labelWidth: 120,
                    readonly: true,
                    id: 'totalCash', // ID for the total cash field
                },
                {
                    cols: [
                        {
                            view: 'button',
                            label: _('Cerrar día'), // Close day button label
                            click: function () {
                                if ($$('gridProduct2').validate()) {
                                    // Validate the grid
                                    // Set total values from the input fields
                                    send.total.initialmoney = $$('initialmoney').getValue();
                                    send.total.expense = $$('totalExpenses').getValue();
                                    send.total.incomes = $$('totalIncomes').getValue();
                                    send.total.incomesCreditCards = $$('incomesCreditCards').getValue();
                                    send.total.total = $$('total').getValue();
                                    send.total.totalCash = $$('totalCash').getValue();
                                    send.CloseBoxId = cur_id; // Set CloseBoxId

                                    // AJAX request to save the close box data
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(devConfig.geturlApi() + 'Accounting/SaveCloseBoxBetShopEdit', send, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message({
                                                    text: _('Verifique que todos los datos sean validos '), // Error message
                                                    title: '¡Error!',
                                                    type: 'alert-error',
                                                });
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var json = JSON.parse(text); // Parse response
                                                if (json.HasError) {
                                                    webix.message({
                                                        text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                                                        title: '¡Error!',
                                                        type: 'alert-error',
                                                    });
                                                } else {
                                                    webix.message(_('Se cerró el día satisfactoriamente')); // Success message
                                                    webix
                                                        .ui({
                                                            id: 'showPDF',
                                                            view: 'window',
                                                            width: 450,
                                                            height: 450,
                                                            head: {
                                                                view: 'toolbar',
                                                                cols: [
                                                                    {
                                                                        view: 'label',
                                                                        label: _('Seleccione tipo de factura'), // Invoice type selection label
                                                                        align: 'center',
                                                                    },
                                                                    {
                                                                        view: 'icon',
                                                                        icon: 'wxi-close',
                                                                        click: function () {
                                                                            this.getTopParentView().hide(); // Close the window
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            position: 'center',
                                                            modal: true,
                                                            body: {
                                                                view: 'form',
                                                                elements: [
                                                                    {
                                                                        cols: [
                                                                            {
                                                                                view: 'button',
                                                                                value: _('POS'), // POS button label
                                                                                click: function () {
                                                                                    webix
                                                                                        .ui({
                                                                                            view: 'window',
                                                                                            head: {
                                                                                                view: 'toolbar',
                                                                                                cols: [
                                                                                                    {
                                                                                                        view: 'label',
                                                                                                        label: _(
                                                                                                            'Factura',
                                                                                                        ), // Invoice label
                                                                                                    },
                                                                                                    {
                                                                                                        view: 'button',
                                                                                                        label: 'X',
                                                                                                        width: 100,
                                                                                                        align: 'right',
                                                                                                        click: "$$('windowfact2').close();", // Close button action
                                                                                                    },
                                                                                                ],
                                                                                            },
                                                                                            id: 'windowfact2',
                                                                                            width: 800,
                                                                                            height: 500,
                                                                                            modal: true,
                                                                                            position: 'center',
                                                                                            body: {
                                                                                                rows: [
                                                                                                    {
                                                                                                        template:
                                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display template
                                                                                                    },
                                                                                                ],
                                                                                            },
                                                                                        })
                                                                                        .show(); // Show the window
                                                                                    var reader = new FileReader(); // File reader for PDF
                                                                                    reader.onload = function (event) {
                                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                                        $$('pdf').parse({
                                                                                            data: event.target.result, // Parse new PDF data
                                                                                        });
                                                                                    };
                                                                                    function b64toBlob(
                                                                                        b64Data,
                                                                                        contentType,
                                                                                        sliceSize,
                                                                                    ) {
                                                                                        // Convert base64 to Blob
                                                                                        contentType = contentType || '';
                                                                                        sliceSize = sliceSize || 512;
                                                                                        var byteCharacters =
                                                                                            atob(b64Data); // Decode base64
                                                                                        var byteArrays = [];
                                                                                        for (
                                                                                            var offset = 0;
                                                                                            offset <
                                                                                            byteCharacters.length;
                                                                                            offset += sliceSize
                                                                                        ) {
                                                                                            var slice =
                                                                                                byteCharacters.slice(
                                                                                                    offset,
                                                                                                    offset + sliceSize,
                                                                                                );
                                                                                            var byteNumbers = new Array(
                                                                                                slice.length,
                                                                                            );
                                                                                            for (
                                                                                                var i = 0;
                                                                                                i < slice.length;
                                                                                                i++
                                                                                            ) {
                                                                                                byteNumbers[i] =
                                                                                                    slice.charCodeAt(i); // Convert characters to byte numbers
                                                                                            }
                                                                                            var byteArray =
                                                                                                new Uint8Array(
                                                                                                    byteNumbers,
                                                                                                ); // Create byte array
                                                                                            byteArrays.push(byteArray); // Add to byte arrays
                                                                                        }
                                                                                        var blob = new Blob(
                                                                                            byteArrays,
                                                                                            {
                                                                                                type: contentType,
                                                                                            },
                                                                                        ); // Create Blob
                                                                                        return blob; // Return Blob
                                                                                    }
                                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                                    var b64Data = json.PdfPOS; // Base64 data for POS PDF
                                                                                    var blob = b64toBlob(
                                                                                        b64Data,
                                                                                        contentType,
                                                                                    ); // Convert to Blob
                                                                                    var file =
                                                                                        window.URL.createObjectURL(
                                                                                            blob,
                                                                                        ); // Create object URL
                                                                                    document.querySelector(
                                                                                        'iframe',
                                                                                    ).src = file; // Set iframe source
                                                                                    var printWindow = window.open(
                                                                                        file,
                                                                                        '',
                                                                                        'width=800,height=500',
                                                                                    ); // Open print window
                                                                                    printWindow.print(); // Print the document
                                                                                },
                                                                            },
                                                                            {
                                                                                view: 'button',
                                                                                value: _('CARTA'), // Letter button label
                                                                                click: function () {
                                                                                    webix
                                                                                        .ui({
                                                                                            view: 'window',
                                                                                            head: {
                                                                                                view: 'toolbar',
                                                                                                cols: [
                                                                                                    {
                                                                                                        view: 'label',
                                                                                                        label: _(
                                                                                                            'Factura',
                                                                                                        ), // Invoice label
                                                                                                    },
                                                                                                    {
                                                                                                        view: 'button',
                                                                                                        label: 'X',
                                                                                                        width: 100,
                                                                                                        align: 'right',
                                                                                                        click: "$$('windowfact2').close();", // Close button action
                                                                                                    },
                                                                                                ],
                                                                                            },
                                                                                            id: 'windowfact2',
                                                                                            width: 800,
                                                                                            height: 500,
                                                                                            modal: true,
                                                                                            position: 'center',
                                                                                            body: {
                                                                                                rows: [
                                                                                                    {
                                                                                                        template:
                                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display template
                                                                                                    },
                                                                                                ],
                                                                                            },
                                                                                        })
                                                                                        .show(); // Show the window
                                                                                    var reader = new FileReader(); // File reader for PDF
                                                                                    reader.onload = function (event) {
                                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                                        $$('pdf').parse({
                                                                                            data: event.target.result, // Parse new PDF data
                                                                                        });
                                                                                    };
                                                                                    function b64toBlob(
                                                                                        b64Data,
                                                                                        contentType,
                                                                                        sliceSize,
                                                                                    ) {
                                                                                        // Convert base64 to Blob
                                                                                        contentType = contentType || '';
                                                                                        sliceSize = sliceSize || 512;
                                                                                        var byteCharacters =
                                                                                            atob(b64Data); // Decode base64
                                                                                        var byteArrays = [];
                                                                                        for (
                                                                                            var offset = 0;
                                                                                            offset <
                                                                                            byteCharacters.length;
                                                                                            offset += sliceSize
                                                                                        ) {
                                                                                            var slice =
                                                                                                byteCharacters.slice(
                                                                                                    offset,
                                                                                                    offset + sliceSize,
                                                                                                );
                                                                                            var byteNumbers = new Array(
                                                                                                slice.length,
                                                                                            );
                                                                                            for (
                                                                                                var i = 0;
                                                                                                i < slice.length;
                                                                                                i++
                                                                                            ) {
                                                                                                byteNumbers[i] =
                                                                                                    slice.charCodeAt(i); // Convert characters to byte numbers
                                                                                            }
                                                                                            var byteArray =
                                                                                                new Uint8Array(
                                                                                                    byteNumbers,
                                                                                                ); // Create byte array
                                                                                            byteArrays.push(byteArray); // Add to byte arrays
                                                                                        }
                                                                                        var blob = new Blob(
                                                                                            byteArrays,
                                                                                            {
                                                                                                type: contentType,
                                                                                            },
                                                                                        ); // Create Blob
                                                                                        return blob; // Return Blob
                                                                                    }
                                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                                    var b64Data = json.Pdf; // Base64 data for letter PDF
                                                                                    var blob = b64toBlob(
                                                                                        b64Data,
                                                                                        contentType,
                                                                                    ); // Convert to Blob
                                                                                    var file =
                                                                                        window.URL.createObjectURL(
                                                                                            blob,
                                                                                        ); // Create object URL
                                                                                    document.querySelector(
                                                                                        'iframe',
                                                                                    ).src = file; // Set iframe source
                                                                                    var printWindow = window.open(
                                                                                        file,
                                                                                        '',
                                                                                        'width=800,height=500',
                                                                                    ); // Open print window
                                                                                    printWindow.print(); // Print the document
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                ],
                                                            },
                                                        })
                                                        .show(); // Show the PDF selection window
                                                    profile.BeginDay = true; // Set profile flag
                                                    vthis.show('/top/dashboard'); // Navigate to dashboard
                                                }
                                            },
                                        });
                                } else {
                                    webix.message({
                                        text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                                        title: '¡Error!',
                                        type: 'alert-error',
                                    });
                                }
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const cur_id = this.getParam('CloseBoxId', true); // Get the CloseBoxId parameter
        var expensesTotal = 0; // Total expenses
        var incomesTotal = 0; // Total incomes
        var totalExpenses = 0; // Total expenses from all sources
        var totalExpensesProducts = 0; // Total expenses from products
        var initialmoney = 0; // Initial money
        var incomesCreditCards = 0; // Total incomes from credit cards

        // AJAX request to get initial money
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetInitialMoney', '{"CloseBoxId":"' + cur_id + '"}', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    initialmoney = resp.Data; // Set initial money
                },
            });

        // Event listener for totalExpenses:sum event
        this.on(this.app, 'totalExpenses:sum', (sum) => {
            totalExpenses = sum.total; // Update total expenses
            sumExpenses(); // Calculate total expenses
        });

        // Event listener for totalExpensesProducts:sum event
        this.on(this.app, 'totalExpensesProducts:sum', (sum) => {
            totalExpensesProducts = sum.total; // Update total expenses from products
            sumExpenses(); // Calculate total expenses
        });

        // Function to sum expenses
        function sumExpenses() {
            expensesTotal = totalExpenses + totalExpensesProducts; // Calculate total expenses
            $$('totalExpenses').setValue(expensesTotal); // Update total expenses field
            sumTotal(); // Calculate total
        }

        var totalIncomes = 0; // Total incomes
        var totalIncomesProducts = 0; // Total incomes from products

        // Event listener for totalIncomes:sum event
        this.on(this.app, 'totalIncomes:sum', (sum) => {
            totalIncomes = sum.total; // Update total incomes
            sumIncomes(); // Calculate total incomes
        });

        // Event listener for totalIncomesProducts:sum event
        this.on(this.app, 'totalIncomesProducts:sum', (sum) => {
            totalIncomesProducts = sum.total; // Update total incomes from products
            sumIncomes(); // Calculate total incomes
        });

        // Event listener for totalCreditCards:sum event
        this.on(this.app, 'totalCreditCards:sum', (sum) => {
            incomesCreditCards = sum.total; // Update total incomes from credit cards
            $$('incomesCreditCards').setValue(incomesCreditCards); // Update credit card incomes field
        });

        // Function to sum incomes
        function sumIncomes() {
            incomesTotal = totalIncomes + totalIncomesProducts; // Calculate total incomes
            $$('totalIncomes').setValue(incomesTotal); // Update total incomes field
            sumTotal(); // Calculate total
        }

        // Function to calculate total
        function sumTotal() {
            webix.delay(
                function () {
                    var total = initialmoney + incomesTotal - expensesTotal; // Calculate total
                    $$('initialmoney').setValue(initialmoney); // Update initial money field
                    $$('total').setValue(total); // Update total field
                    $$('totalCash').setValue(total - incomesCreditCards); // Update total cash field
                },
                '',
                '',
                100,
            );
        }
    }
}

// FILE DOCUMENTED
